import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState: ISWLicensePackageState = {
  data: null,
  documents: [],
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  docCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  details: null,
};

export const sWLicensePackageSlice = createSlice({
  name: "sWLicensePackage",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceSWLicensePackage: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    setSWLicensePackageDocuments: (state, action) => {
      const { data } = action.payload;
      state.documents = data;
      state.docCount = state.documents.length;
    },
    addSWLicensePackageDocuments: (state, action) => {
      const newItem = action.payload.data;
      state.documents = [newItem, ...state.documents];
      state.docCount = state.documents.length;
    },
    resetSWLicensePackageDocuments: (state) => {
      state.documents = [];
    },
    addSWLicensePackage: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updateSWLicensePackage: (state, action) => {
      const { localID, data } = action.payload;
      if (localID !== undefined && localID >= 0 && state.data) {
        state.data[localID] = data;
      }
      state.details = data;
    },
    deleteSWLicensePackage: (state, action) => {
      const sWLicensePackageToRemove: ISWLicensePackage = action.payload.data;
      const newSWLicensePackageData =
        state.data &&
        state.data.filter((sWLicensePackage: ISWLicensePackage) => {
          return sWLicensePackage.id !== sWLicensePackageToRemove.id;
        });
      state.data = newSWLicensePackageData;
      state.totalCount = state.totalCount - 1;
    },
    deleteSWLicensePackageDocument: (state, action) => {
      const toRemove: IDocument = action.payload;
      const newData = state.documents.filter((document: IDocument) => {
        return document.documentName !== toRemove.documentName;
      });
      state.documents = newData;
      state.docCount = state.documents.length;
    },
    setSWLicensePackageDetails: (state, action) => {
      state.details = action.payload.data;
    },
  },
});

export const sWLicensePackageActions = sWLicensePackageSlice.actions;

export default sWLicensePackageSlice.reducer;
